import { render, staticRenderFns } from "./UpdateOrgManual.vue?vue&type=template&id=2db7da0c"
import script from "./UpdateOrgManual.vue?vue&type=script&lang=js"
export * from "./UpdateOrgManual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports